class ArticleGlossary extends HTMLElement {
    constructor() {
        super();

        this.searchInput = this.querySelector('[data-search-input]');
        this.searchButton = this.querySelector('[data-search-button]');

        this.searchButton.addEventListener('click', () => this.searchBlogs());
        this.searchInput.addEventListener('keyup', () => this.detectKey(event));

        this.resultsArea = this.querySelector('#results-area');

        this.tagButtons = Array.from(this.querySelectorAll('[data-tag-button]'));
        this.tagButtons.forEach(button => {
            button.addEventListener('click', () => this.tagSeachBlogs(button));
        });

        this.tagSelectElem = this.querySelector('[data-tag-select]');
        this.tagSelectElem.addEventListener('change', () => this.tagSelect());

        this.clearButton = this.querySelector('[data-clear-filters]');
        this.clearButton.addEventListener('click', () => this.searchBlogs());
        this.clearButton.addEventListener('click', () => this.hideClear(this.clearButton));
        this.clearButtonContainer = this.clearButton.parentElement;

       this.pageLoad();
    }

    async pageLoad() {
        const allCards = Array.from(this.querySelectorAll('[data-blog-date]'));

        let grid = document.createElement('ul');
        grid.id = "product-grid";
        grid.classList.add('products', 'collection', 'row');

        allCards.sort(function(a,b) {
            return +b.getAttribute('data-blog-date') - +a.getAttribute('data-blog-date');
        });

        this.resultsArea.innerHTML = '';

        this.resultsArea.append(grid);

        var loopIndex = 0;
        allCards.forEach(card => {
            grid.append(card);
            if(loopIndex < 3){
                card.classList.add('top-row');
            }else {
                card.classList.add('second-row');
            }
            loopIndex++;
        });

    }

    detectKey(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.searchBlogs();
        }
    }

    clearFilters() {
        this.clearButtonContainer.classList.remove('is-hidden');
    }

    hideClear() {
        this.searchInput.value = '';
        this.clearButtonContainer.classList.add('is-hidden');
        this.tagButtons.forEach(button => {
            button.classList.remove('active-filter')
        })
    }

    async searchBlogs() {
        let q = this.searchInput.value;

        if(q == ''){
            let types = this.getAttribute('data-blog-types');
            let markup = '';

            const url = (
                `/search?` +
                new URLSearchParams({ view: "blogs", q: `${q}`, type: "article", articleTypes: `${types}` }).toString()
            );
            const data = await fetchData(url);
            markup = markup.concat(data);
            let parsedata = new DOMParser().parseFromString(markup, "text/html").querySelector('body').innerHTML;

            this.resultsArea.innerHTML = parsedata;
            this.pageLoad();
            this.hideClear();
            return;
        }

        let markup = '';

        const url = (
            `/search?` +
            new URLSearchParams({ view: "blogs", q: `${q}`, type: "article" }).toString()
        );

        const data = await fetchData(url);
        markup = markup.concat(data);
        let parsedata = new DOMParser().parseFromString(markup, "text/html").querySelector('body').innerHTML;

        this.resultsArea.innerHTML = parsedata;
    }

    async tagSeachBlogs(button) {
        let q = button.getAttribute('data-tag-button');
        let markup = '';
        this.tagButtons.forEach(button => {
            button.classList.remove('active-filter')
        })
        button.classList.add('active-filter')
        const url = (
            `/search?` +
            new URLSearchParams({ view: "blogs", q: `${q}`, type: "article" }).toString()
        );
        const data = await fetchData(url);
        markup = markup.concat(data);
        let parsedata = new DOMParser().parseFromString(markup, "text/html").querySelector('body').innerHTML;
        this.resultsArea.innerHTML = parsedata;
        this.clearFilters();

    }

    async tagSelect() {
        let q = this.tagSelectElem.value;
        let markup = '';
        const url = (
            `/search?` +
            new URLSearchParams({ view: "blogs", q: `${q}`, type: "article" }).toString()
        );

        const data = await fetchData(url);
        markup = markup.concat(data);
        let parsedata = new DOMParser().parseFromString(markup, "text/html").querySelector('body').innerHTML;
        this.resultsArea.innerHTML = parsedata;
        this.clearFilters();

    }
}
if (!customElements.get('article-glossary')) {
    customElements.define('article-glossary', ArticleGlossary);
}

async function fetchData(url) {
    let json;
    try {
        const response = await fetch(url);
        json = await response.json();
    } catch (error) {
        if (error instanceof SyntaxError) {
            console.log('❌ fetchData syntax error:', error);
            return;
        } else {
            console.log('❌ fetchData error:', error);
            return;
        }
    } finally {
        if (json) {
            return json;
        }
    }
}

async function articlePaginate(elem) {
    let paginationData = JSON.parse(elem.dataset.pagination);
    let markup = '';
    if(!paginationData.next.url){
        elem.classList.add('is-hidden');
        return;
    }
    let url = paginationData.next.url;

    const data = await fetchData(url);
    markup = markup.concat(data);
    let parsedata = new DOMParser().parseFromString(markup, "text/html").querySelector('body').innerHTML;
    let resultsArea = document.getElementById('results-area');
    let paginationResults = document.getElementById('pagination-results');
    paginationResults.innerHTML += parsedata;

    let paginatedContent = Array.from(paginationResults.querySelectorAll('[data-blog-date]'));
    let grid = resultsArea.querySelector('#product-grid');

    let newPagainationData = paginationResults.querySelector('[data-pagination]');
    if(newPagainationData){
        newPagainationData = newPagainationData.dataset.pagination;
        elem.dataset.pagination = newPagainationData;
    }


    paginatedContent.forEach(card => {
        grid.append(card);
    });


    paginationData = JSON.parse(elem.dataset.pagination);

    if(!newPagainationData){
        paginationData.current_page = paginationData.pages
    }

    console.log(paginationData);

    if(paginationData.current_page >= paginationData.pages){
        elem.classList.add('is-hidden');
    }
    paginationResults.innerHTML = '';
}